import imagesLoaded from "imagesloaded";
import Masonry from "masonry-layout";

const Frontify = (function () {
  function init() {
    const frontifyContainer = document.querySelector(
      ".frontify-listing-page__list-items",
    );

    if (frontifyContainer != null) {
      const grid = new Masonry(frontifyContainer, {
        gutter: 30,
      });

      const imgLoad = imagesLoaded(frontifyContainer);

      imgLoad.on("always", function () {
        if (grid.layout) grid.layout();
      });

      imgLoad.on("progress", function () {
        if (grid.layout) grid.layout();
      });
    }
  }

  return {
    init,
  };
})();

export default Frontify;
